// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1g0-k","inner":"Footer_inner__2RXLE"};